import { NumberBox } from '@apply/components';
import { useState } from 'react';
import { useExperienceUnitCount } from '../../../../fields/ExperienceFields';

interface UnitProps {
    experienceId: string | undefined;
    required: boolean;
    minimumUnits?: number;
    readOnly?: boolean;
}

export const Units: React.FC<UnitProps> = ({ experienceId, required, minimumUnits, readOnly = false }) => {
    const label = 'Units';
    const [numberUnits, set_numberUnits] = useExperienceUnitCount(experienceId);

    const [helperText, set_helperText] = useState<string>('');
    const handleNumberUnits = (newvalue: number) => {
        const result = Number(newvalue) || undefined;
        set_numberUnits(result);
    };

    const onKeyUp = (e: any) => {
        const value = e.event.currentTarget.value;
        if (value < 5) {
            set_helperText('Select different structure type for less than five');
        } else {
            set_helperText('');
        }
    };

    return (
        <>
            <NumberBox
                value={numberUnits}
                onChange={handleNumberUnits}
                label={label}
                required={required}
                min={minimumUnits}
                onKeyUp={onKeyUp}
                helperText={helperText}
                readOnly={readOnly}
                max={100}
            />
        </>
    );
};
